import { DownOutlined } from '@ant-design/icons';

export const getOption = (value: string, lang: string, customStyle?: string) => {
   const getLabel = (es: string, en: string, fr: string, it: string) => {
      switch (lang) {
         case 'en':
            return en;
         case 'fr':
            return fr;
         case 'it':
            return it;
         default:
            return es;
      }
   };

   switch (value) {
      case 'co':
         return renderOption('🇨🇴', 'co', getLabel('Colombia', 'Colombia', 'Colombie', 'Colombia'), customStyle);
      case 'en':
         return renderOption('🇺🇸', 'eu', getLabel('Estados Unidos', 'United States', 'États-Unis', 'Stati Uniti'), customStyle);
      case 'es-ES':
         return renderOption('🇪🇸', 'es-ES', getLabel('España', 'Spain', 'Espagne', 'Spagna'), customStyle);
      case 'br':
         return renderOption('🇧🇷', 'br', getLabel('Brasil', 'Brazil', 'Brésil', 'Brasile'), customStyle);
      case 'ar':
         return renderOption('🇦🇷', 'ar', getLabel('Argentina', 'Argentina', 'Argentine', 'Argentina'), customStyle);
      case 'pa':
         return renderOption('🇵🇦', 'pa', getLabel('Panamá', 'Panama', 'Panama', 'Panama'), customStyle);
      case 'cl':
         return renderOption('🇨🇱', 'cl', getLabel('Chile', 'Chile', 'Chili', 'Cile'), customStyle);
      case 'cr':
         return renderOption('🇨🇷', 'cr', getLabel('Costa Rica', 'Costa Rica', 'Costa Rica', 'Costa Rica'), customStyle);
      case 'pe':
         return renderOption('🇵🇪', 'pe', getLabel('Perú', 'Peru', 'Pérou', 'Perù'), customStyle);
      case 'pr':
         return renderOption('🇵🇷', 'pr', getLabel('Puerto Rico', 'Puerto Rico', 'Porto Rico', 'Porto Rico'), customStyle);
      case 'fr':
         return renderOption('🇫🇷', 'fr', getLabel('Francia', 'France', 'France', 'Francia'), customStyle);
      case 'it':
         return renderOption('🇮🇹', 'it', getLabel('Italia', 'Italy', 'Italie', 'Italia'), customStyle);
      case 'es-UY':
         return renderOption('🇺🇾', 'es-UY', getLabel('Uruguay', 'Uruguay', 'Uruguay', 'Uruguay'), customStyle);
      case 'es-PY':
         return renderOption('🇵🇾', 'es-PY', getLabel('Paraguay', 'Paraguay', 'Paraguay', 'Paraguay'), customStyle);
      case 'es':
      default:
         return renderOption('🇲🇽', 'mx', getLabel('México', 'Mexico', 'Mexique', 'Messico'), customStyle);
   }
};

/* Helper para no repetir el mismo JSX */
const renderOption = (flag: string, aria: string, label: string, customStyle?: string) => (
   <div
      style={{
         width: '100%',
         textOverflow: 'ellipsis',
         whiteSpace: 'nowrap',
         overflow: 'hidden',
         display: 'flex',
         justifyContent: 'space-between',
         alignItems: 'center',
      }}>
      <div className={customStyle || ''}>
         <p>
            <span role='img' aria-label={aria}>
               {flag}
            </span>
            {label}
         </p>
      </div>
      <div>
         <DownOutlined style={{ color: '#D5D5D5' }} />
      </div>
   </div>
);
